import EmbeddedYoutube from 'containers/CollectionPage/views/EmbeddedYoutube';

const HeroSection = () => (
  <section className="bg-black">
    <div className="section-container !py-10 flex flex-col gap-[37px]">
      <h1 style={{ textIndent: '-9999px', height: '32px' }}>
        Zoom Meeting/Workplace Premium | Xooply.ID
      </h1>

      <p className="-mt-[69px] text-white text-center text-xl lg:text-3xl font-[600]">
        Solusi Mudah dan Terpercaya untuk Kebutuhan Zoom Anda,
        <br />
        Hanya di Xooply.ID
      </p>

      <div className="2xl:px-28">
        <EmbeddedYoutube videoId="P1f4dvDMk6g" />
      </div>

      <div className="flex flex-col lg:flex-row gap-[15px] 2xl:px-28">
        <h2 className="text-xl lg:text-3xl lg:basis-[457px] shrink-0 text-white font-[600]">
          Tahukah Anda? Ternyata ZOOM bukan sekedar “meeting online” lho...
        </h2>

        <p className="text-white text-justify text-lg lg:text-xl">
          Banyak yang mengenal Zoom sebagai platform untuk rapat virtual. Tapi, tahukah Anda? Zoom
          punya <span className="font-bold">solusi canggih</span> yang bisa mengubah cara tim
          bekerja, berkomunikasi, dan berkolaborasi.
        </p>
      </div>
    </div>
  </section>
);

export default HeroSection;
